import { pxChangeVw } from "@/utils";
export default function QualityScale() {
  return (
    <div>
      <div className="flex-[1] flex flex-col">
        <div className='flex-[1] text-12 flex flex-col gap-y-8 p-[8px_8px_16px] relative after:content-[""] after:bg-[rgba(255,255,255,0.18)] after:w-[calc(100%-16px)] after:h-1 after:absolute after:left-50% after:bottom-0 after:translate-x-[-50%]'>
          <div
            className='relative pb-5 w-full after:content-[""] after:w-35 after:h-2 after:rounded-1 after:bg-[var(--data-color)] after:absolute after:bottom-0 after:left-0'
            //  @ts-ignore
            style={{ "--data-color": "#38D3FF" }}
          ></div>
          <p style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <i>Excellent</i>
            <i>0 - 19</i>
          </p>
          <p style={{ fontSize: pxChangeVw("10px"), color: "rgba(255,255,255,0.8)" }}>
            The air quality is ideal for most individuals; enjoy your normal outdooractivities.
          </p>
        </div>

        <div className='flex-[1] text-12 flex flex-col gap-y-8 p-[8px_8px_16px] relative after:content-[""] after:bg-[rgba(255,255,255,0.18)] after:w-[calc(100%-16px)] after:h-1 after:absolute after:left-50% after:bottom-0 after:translate-x-[-50%]'>
          <div
            className='relative pb-5 w-full after:content-[""] after:w-35 after:h-2 after:rounded-1 after:bg-[var(--data-color)] after:absolute after:bottom-0 after:left-0'
            //  @ts-ignore
            style={{ "--data-color": "#C4FF89" }}
          ></div>
          <p style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <i>Fair</i>
            <i>20 - 49</i>
          </p>
          <p style={{ fontSize: pxChangeVw("10px"), color: "rgba(255,255,255,0.8)" }}>
            The air quality is generally acceptable for most individuals. However,sensitive groups may experience minor
            to moderate symptoms from long-term exposure.
          </p>
        </div>

        <div className='flex-[1] text-12 flex flex-col gap-y-8 p-[8px_8px_16px] relative after:content-[""] after:bg-[rgba(255,255,255,0.18)] after:w-[calc(100%-16px)] after:h-1 after:absolute after:left-50% after:bottom-0 after:translate-x-[-50%]'>
          <div
            className='relative pb-5 w-full after:content-[""] after:w-35 after:h-2 after:rounded-1 after:bg-[var(--data-color)] after:absolute after:bottom-0 after:left-0'
            //  @ts-ignore
            style={{ "--data-color": "#FFFD29" }}
          ></div>
          <p style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <i>Poor</i>
            <i>50 - 99</i>
          </p>
          <p style={{ fontSize: pxChangeVw("10px"), color: "rgba(255,255,255,0.8)" }}>
            The air has reached a high level of pollution and is unhealthy for sensitivegroups. Reduce time spent
            outside if you are feeling symptoms such asdifficulty breathing or throat irritation.
          </p>
        </div>

        <div className='flex-[1] text-12 flex flex-col gap-y-8 p-[8px_8px_16px] relative after:content-[""] after:bg-[rgba(255,255,255,0.18)] after:w-[calc(100%-16px)] after:h-1 after:absolute after:left-50% after:bottom-0 after:translate-x-[-50%]'>
          <div
            className='relative pb-5 w-full after:content-[""] after:w-35 after:h-2 after:rounded-1 after:bg-[var(--data-color)] after:absolute after:bottom-0 after:left-0'
            //  @ts-ignore
            style={{ "--data-color": "#FF628A" }}
          ></div>
          <p style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <i>Unhealthy</i>
            <i>100 - 149</i>
          </p>
          <p style={{ fontSize: pxChangeVw("10px"), color: "rgba(255,255,255,0.8)" }}>
            Health effects can be immediately felt by sensitive groups. Healthyindividuals may experience difficulty
            breathing and throat irritation withprolonged exposure. Limit outdoor activity.
          </p>
        </div>

        <div className='flex-[1] text-12 flex flex-col gap-y-8 p-[8px_8px_16px] relative after:content-[""] after:bg-[rgba(255,255,255,0.18)] after:w-[calc(100%-16px)] after:h-1 after:absolute after:left-50% after:bottom-0 after:translate-x-[-50%]'>
          <div
            className='relative pb-5 w-full after:content-[""] after:w-35 after:h-2 after:rounded-1 after:bg-[var(--data-color)] after:absolute after:bottom-0 after:left-0'
            //  @ts-ignore
            style={{ "--data-color": "#D662FD" }}
          ></div>
          <p style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <i>Very Unhealthy</i>
            <i>150 - 249</i>
          </p>
          <p style={{ fontSize: pxChangeVw("10px"), color: "rgba(255,255,255,0.8)" }}>
            Health effects will be immediately felt by sensitive groups and shouldavoid outdoor activity. Healthy
            individuals are likely to ex-periencedifficulty breathing and throat irritation; consider staying indoors
            andrescheduling outdoor activities
          </p>
        </div>

        <div className='flex-[1] text-12 flex flex-col gap-y-8 p-[8px_8px_16px] relative after:content-[""] after:bg-[transparent] after:w-[calc(100%-16px)] after:h-0 after:absolute after:left-50% after:bottom-0 after:translate-x-[-50%]'>
          <div
            className='relative pb-5 w-full after:content-[""] after:w-35 after:h-2 after:rounded-1 after:bg-[var(--data-color)] after:absolute after:bottom-0 after:left-0'
            //  @ts-ignore
            style={{ "--data-color": "#D662FD" }}
          ></div>
          <p style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <i>Dangerous</i>
            <i>250 +</i>
          </p>
          <p style={{ fontSize: pxChangeVw("10px"), color: "rgba(255,255,255,0.8)" }}>
            Any exposure to the air, even for a few minutes, can lead to serious healtheffects on everybody. Avoid
            outdoor activities.
          </p>
        </div>
      </div>
    </div>
  );
}
